import { render, staticRenderFns } from "./S6.vue?vue&type=template&id=666d70b4&scoped=true&"
import script from "./S6.vue?vue&type=script&lang=js&"
export * from "./S6.vue?vue&type=script&lang=js&"
import style0 from "./S6.vue?vue&type=style&index=0&id=666d70b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666d70b4",
  null
  
)

export default component.exports